import React, { useState, useEffect } from "react";
import SearchCateField from "../../../components/textfield/searchCateField";
import { Table, TableColumn } from "../../../components/table";
//import Select from "../../../components/select/selectField";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import Icon from "@mdi/react";
import {
  mdiPlusCircle,
  mdiMenuRight,
  mdiMinusCircle,
  mdiArrowLeftThick,
} from "@mdi/js";
import EmptyModel from "../../../components/modal/emptyModal";
import MainButton from "../../../components/button/mainButton";
import Input from "../../../components/textfield/input";
import { useHistory, useParams, useLocation } from "react-router-dom";
import "../../../assets/styles/admin/usedcourse.scss";
import axios from "axios";
import queryString from "query-string";
import {
  Form,
  Select,
  Typography,
  message,
  DatePicker,
  InputNumber,
} from "antd";
import {
  calculatePercen,
  getPromotionTypeName,
  numberWithCommas,
} from "../../../helpers/functions";

interface ParamTypes {
  id?: string;
}

const messageText = "กรุณากรอกข้อมูล!";

const CourseListPro1 = () => {
  const { id } = useParams<ParamTypes>();
  const { search } = useLocation();
  const query = queryString.parse(search);
  const [form] = Form.useForm();
  const [formSelected] = Form.useForm();
  const [formSelectedOtherTreatment] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [modalSelectOther, setModalSelectOther] = useState(false);
  const [modalSelectOtherType, setModalSelectOtherType] =
    useState<string>("list");
  const [searchText, setSearchText] = useState<string>("");
  const [searchType, setSearchType] = useState<string>("name");
  const [columnSelectTreatments, setColumnSelectTreatments] = useState<any>([]);
  const [selectedOtherTreatments, setSelectedOtherTreatments] = useState<any>(
    []
  );
  const [dataSelectedOtherTreatments, setDataSelectedOtherTreatments] =
    useState<any>([]);
  const [
    totalDataSelectedOtherTreatments,
    setTotalDataSelectedOtherTreatments,
  ] = useState<number>(0);
  const [itemSelectedOther, setItemSelectedOther] = useState<any>({});
  const { Option } = Select;
  const history = useHistory();
  const formatnum = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const [state, setState] = useState<any>({
    code: "",
    name: "",
    promotionType: "",
    promotionTypeName: "",
    discount: "",
    quantity: "",
    validityPeriod: "",
    total: "",
    used: "",
    balance: "",
    // headData: {},
    // courses: [],
    selectedTreatments: [],
  });
  const [listCourses, setListCourses] = useState<any>([]);
  const [procedureTypes, setProcedureTypes] = useState<any>([]);
  const [priceVals, setPriceVals] = useState<any>([]);
  const [treatments, setTreatments] = useState<any>([]);
  const [allTreatments, setAllTreatments] = useState<any>([]);
  const [dataTreatments, setDataTreatments] = useState<any>([]);
  const [dataSelectedTreatments, setDataSelectedTreatments] = useState<any>([]);
  const Datas = {
    promoCode: "PRO-63060001",
    namePromo: "MEMBER Package มูลค่า 500,000",
    catePromo: "MEMBERSHIP",
    creditPrice: "300,000.00",
    discount: "-",
    amount: "-",
    days: "-",
    used: "0",
    remain: "300,000.00",
    unit: "วงเงิน",
  };

  const columns = [
    {
      title: "รหัส<br/>Code",
      align: "center",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
    },
    {
      title: "ราคาต่อหน่วย<br/>Unit Price",
      align: "center",
    },
    {
      title: "จำนวนที่จะใช้<br/>Amount Used",
      align: "center",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
    },
    {
      title: "รวมราคา<br/>Total Price",
      align: "center",
    },
    {
      title: "หลังหักส่วนลด<br/>After Discount",
      align: "center",
    },
  ];

  const _columns = [
    {
      title: "",
    },
    {
      title: "รหัส<br/>Code",
      align: "center",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
    },
    {
      key: "price",
      title: "ราคาต่อหน่วย<br/>Unit Price",
      align: "center",
    },
    {
      title: "เลือก<br/>Select",
      align: "center",
    },
  ];

  const _selectTreatmentPackageColumns = [
    {
      title: "",
    },
    {
      title: "รหัส<br/>Code",
      align: "center",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
    },
    {
      title: "จำนวน/คอร์ส<br/>No./Course",
      align: "center",
    },
    {
      title: "จำนวน<br/>Quantity",
      align: "center",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
    },
    {
      key: "price",
      title: "ราคาต่อหน่วย<br/>Unit Price",
      align: "center",
    },
    {
      title: "ส่วนลด<br/>Discount",
      align: "center",
    },
    {
      title: "รวมราคา<br/>PriceTotal",
      align: "center",
    },
    {
      title: "เลือก<br/>Select",
      align: "center",
    },
  ];

  const _selectedOtherListColumns = [
    {
      title: "",
    },
    {
      title: "รหัส<br/>Code",
      align: "center",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
    },
    {
      title: "ราคาต่อหน่วย<br/>Unit Price",
      align: "center",
    },
    {
      title: "จำนวนที่ใช้<br/>Amount Used",
      align: "center",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
    },
    {
      key: "price",
      title: "ส่วนลด<br/>Discount",
      align: "center",
    },
    {
      title: "รวมราคา<br/>Total Price",
      align: "center",
    },
    {
      title: "เลือก<br/>Select",
      align: "center",
    },
  ];

  const _dataprocedure = [
    {
      _id: 1,
      code: "ATFS0802",
      orderlist: "Laser Face",
      unit: "Area",
    },
    {
      _id: 2,
      code: "AFS0803",
      orderlist: "Laser Body",
      unit: "Area",
    },
    {
      _id: 4,
      code: "AFS0804",
      orderlist: "Laser leg",
      unit: "Area",
    },
    {
      _id: 5,
      code: "AFS0805",
      orderlist: "Laser Face2",
      unit: "Area",
    },
    {
      _id: 6,
      code: "AFS0806",
      orderlist: "Laser body2",
      unit: "Area",
    },
    {
      _id: 7,
      code: "AFS0807",
      orderlist: "Laser body2",
      unit: "Area",
    },
  ];

  function onClose() {
    setIsOpen(false);
  }
  function onClose2() {
    setIsOpen2(false);
  }

  const getAPIs = async () => {
    // api 1
    // api 2

    // const _data = await axios.get('/courses')
    // const procedureTypes = await axios.get('/procedureTypes')
    const headData = Datas;
    setState({ ...state, headData: headData });
    //setDats(headData);

    console.log("headData", headData);
    // setDats(xdata)

    setListCourses(_dataprocedure);

    setPriceVals([
      {
        value: "id0001",
        code: "normal",
        name: `${formatnum(30000)}`,
      },
      {
        value: "id002",
        code: "promotion",
        name: `${formatnum(25000)}`,
      },
    ]);
  };

  const initData = () => {
    setProcedureTypes([
      {
        value: "name",
        label: "Search for Name",
      },
      {
        value: "code",
        label: "Search for Code",
      },
    ]);

    setColumnSelectTreatments([..._columns]);
  };

  const getData = async () => {
    const soId = id;
    const itemId = query.itemId;

    try {
      const { data } = await axios.get(
        `/use-courses/get-promotion?soId=${soId}&itemId=${itemId}`
      );
      if (!data) return;

      console.log("data =>", data);

      const promotionTypeName = getPromotionTypeName(data.promotionType);

      setState({ ...state, ...data });

      const newData = {
        ...state,
        ...data,
        promotionTypeName,
        total: data.formatTotal,
        used: data.formatUsed,
        balance: data.formatBalance,
        discount: numberWithCommas(data.discount, 2),
      };

      form.setFieldsValue(newData);
    } catch (err) {
      console.log("err =>", err);
    }
  };

  const getTreatments = async (value: any = "") => {
    console.log("get treatments...", value);

    // const { data }: any = await axios(`/treatments?${searchType}=${value}`);
    const { data }: any = await axios(
      `/use-courses/pro/treatments?soId=${id}&promotionId=${query.itemId}&${searchType}=${value}`
    );
    if (!data) return;

    console.log("data treatments =>", data);

    const items = data?.data;

    setTreatments([...items]);
  };

  const getAllTreatments = async (value: any = "") => {
    console.log("get treatments...", value);

    // const { data }: any = await axios(`/treatments?${searchType}=${value}`);
    const { data }: any = await axios(`/treatments?${searchType}=${value}`);
    if (!data) return;

    console.log("data treatments =>", data);

    const items = data?.data?.map((x: any) => {
      const item: any = { ...x };

      item.pricePerUnit = item.price?.normal?.coursePriceLocal;

      item.formatPricePerUnit = numberWithCommas(item.pricePerUnit, 2);

      return item;
    });

    setAllTreatments([...items]);
  };

  useEffect(() => {
    console.log("dataTreatments =>", dataTreatments);
  }, [dataTreatments]);

  useEffect(() => {
    const newTreatments = [...treatments].map((x: any) => {
      const treatment = { ...x };
      const { price, discount } = treatment?.promotion;

      let noCourse = 1;
      let totalPrice = 0;

      if (state.promotionType === "package") {
        totalPrice = price - discount;
      }

      return {
        ...treatment,
        promotion: { ...treatment?.promotion, noCourse, totalPrice },
      };
    });
    setDataTreatments(newTreatments);
  }, [treatments]);

  useEffect(() => {
    const items = state.selectedTreatments.map((x: any) => {
      const item: any = { ...x };
      let price = 0;
      let totalPrice = 0;
      let afterDiscount = 0;
      let priceUsed = 0;

      console.log("item =>", item);
      console.log("state.promotionType =>", state.promotionType);
      console.log("state =>", state);

      if (state.promotionType === "buffet_special") {
        price = item.price?.special?.coursePriceLocal;
        totalPrice = item.price?.special?.coursePriceLocal * item.amountUsed;
        priceUsed = state.discount
          ? item.price?.special?.coursePriceLocal -
            (item.price?.special?.coursePriceLocal * state.discount) / 100
          : item.price?.special?.coursePriceLocal;
        afterDiscount = priceUsed * item.amountUsed;
      } else if (state.promotionType === "buffet_specific_treatment") {
        console.log("here...");
        price = state.total / state.quantity;
        totalPrice = price * item.amountUsed;
        priceUsed = state.discount
          ? price - (price * state.discount) / 100
          : price;
        afterDiscount = priceUsed * item.amountUsed;
      } else if (state.promotionType === "package") {
        console.log("here...");
        price = item?.promotion?.price - item?.promotion?.discount;
        totalPrice = price * item.amountUsed;
        priceUsed = state.discount
          ? price - (price * state.discount) / 100
          : price;
        afterDiscount = priceUsed * item.amountUsed;
      } else {
        price = item.price?.normal?.coursePriceLocal;
        totalPrice = item.price?.normal?.coursePriceLocal * item.amountUsed;
        afterDiscount = state.discount
          ? item.price?.normal?.coursePriceLocal -
            (item.price?.normal?.coursePriceLocal * state.discount) / 100
          : item.price?.normal?.coursePriceLocal;
        afterDiscount = priceUsed * item.amountUsed;
      }

      item.price = price;
      item.totalPrice = totalPrice;
      item.priceUsed = priceUsed;
      item.afterDiscount = afterDiscount;
      item.formatPrice = numberWithCommas(price, 2);
      item.formatTotalPrice = numberWithCommas(totalPrice, 2);
      item.formatAfterDiscount = numberWithCommas(afterDiscount, 2);
      return item;
    });

    setDataSelectedTreatments([...items]);
  }, [state.selectedTreatments]);

  useEffect(() => {
    // getAPIs();
    initData();
    getData();
  }, []);

  function onHandledata(data: any) {
    console.log("data =>", data);

    const newData = { ...data, otherTreatments: [], amountUsed: 1 };

    // const selectedTreatments = [...state.selectedTreatments];
    // selectedTreatments.push(data);

    const selectedTreatments = [newData];

    setState({ ...state, selectedTreatments });

    const index = selectedTreatments.length - 1;

    formSelected.setFieldValue(`amount-used-${index}`, 1);

    // setDataChooses(data);
    //const data = state.data
  }

  function onHandledataSelectOther(data: any) {
    console.log("data =>", data);

    const newData = { ...data, amountUsed: 1, discount: 0 };

    // const selectedTreatments = [...state.selectedTreatments];
    // selectedTreatments.push(data);

    const selectedTreatments = [...selectedOtherTreatments];
    selectedTreatments.push(newData);
    console.log("selectedTreatments =>", selectedTreatments);

    setSelectedOtherTreatments(selectedTreatments);
    // setState({ ...state, selectedTreatments });

    const index = selectedTreatments.findIndex(
      (x: any) => x._id?.toString() === data?._id?.toString()
    );

    formSelectedOtherTreatment.setFieldValue(
      `amount-used-select-other-${index}`,
      1
    );

    formSelectedOtherTreatment.setFieldValue(
      `discount-select-other-${index}`,
      0
    );

    // setDataChooses(data);
    //const data = state.data
  }

  useEffect(() => {
    console.log("selectedOtherTreatments v3 =>", selectedOtherTreatments);
    const selectedTreatments = [...selectedOtherTreatments].map((x: any) => {
      const item: any = { ...x };

      const price = item.pricePerUnit;
      item.price = price;
      item.totalPrice = price * item.amountUsed + item.discount || 0;
      item.formatTotalPrice = numberWithCommas(item.totalPrice, 2);
      return item;
    });
    const total =
      selectedTreatments.reduce((prev, curr) => prev + curr.totalPrice, 0) || 0;
    setDataSelectedOtherTreatments(selectedTreatments);
    setTotalDataSelectedOtherTreatments(total);
  }, [selectedOtherTreatments]);

  const onPriceChange = (value: any, index: number) => {
    let courses = state.selectedTreatments;

    const obj = priceVals.find((x: any) => x.value === value);
    console.log("value =>", value);
    console.log("obj =>", obj);

    if (obj) {
      if (obj.code === "normal") {
        courses[index].typePrice = "Normal";
      } else {
        courses[index].typePrice = "Promotion";
      }
    }

    courses[index].price = value;
    setState({ ...state, courses });
  };

  const searchChange = (value: any) => {
    // console.log("search value =>", value);
    setSearchText(value);

    getTreatments(value);
  };
  const searchTypeChange = (value: any) => {
    // console.log("search type value =>", value);
    setSearchType(value);

    getTreatments(searchText);
  };

  const searchChangeSelectOther = (value: any) => {
    // console.log("search value =>", value);
    setSearchText(value);

    getAllTreatments(value);
  };
  const searchTypeChangeSelectOther = (value: any) => {
    // console.log("search type value =>", value);
    setSearchType(value);

    getAllTreatments(searchText);
  };

  const onFinish = async (values: any) => {
    console.log("on finish...", values);
  };

  useEffect(() => {
    if (state) {
      console.log("state change =>", state);
    }
  }, [state]);

  const onSubmit = () => {
    formSelected.submit();
  };

  const onClickSelectTreatments = async () => {
    getTreatments();

    const column: any = columnSelectTreatments.find(
      (x: any) => x.key === "price"
    );

    if (state.promotionType === "buffet_special") {
      column.title = "ราคาบุฟเฟ่ต์<br />Buffet";
    } else {
      column.title = "ราคาต่อหน่วย<br/>Unit Price";
    }

    setColumnSelectTreatments([...columnSelectTreatments]);

    setIsOpen(true);
  };

  const onFormSelectedFailed = () => {
    message.warning(
      "กรุณาป้อนข้อมูลในรายการที่เลือกให้ครบถ้วน! / Please complete the information in the selected list!"
    );
    // console.log("failed....");
  };

  const onFormSelectedFinish = async (values: any) => {
    // console.log("on finish...", values);

    // validate
    if (!state.selectedTreatments.length) {
      message.warning("กรุณาเลือกรายการ! / Please select an item!");
      return;
    }

    // const mapSelectedTreatments = [
    //   ...state.selectedTreatments.map((x: any) => {
    //     const price = x.price?.normal?.coursePriceLocal;
    //     const priceUsed = price - (price * state.discount) / 100;
    //     const treatment = {
    //       _id: x._id,
    //       unitPrice: price,
    //       amountUsed: x.amountUsed,
    //       totalPrice: price * x.amountUsed,
    //       priceUsed,
    //       afterDiscount: priceUsed * x.amountUsed,
    //     };
    //     return treatment;
    //   }),
    // ];
    const mapSelectedTreatments = [
      ...dataSelectedTreatments?.map((x: any) => ({
        ...x,
        otherTreatments: x.otherTreatments?.map((y: any) => ({
          _id: y._id,
          price: y.price,
          amountUsed: y.amountUsed,
          discount: y.discount,
        })),
      })),
    ];

    // console.log("mapSelectedTreatments =>", mapSelectedTreatments);
    // return;

    try {
      const body = {
        soId: id,
        itemId: query.itemId,
        selectedTreatments: mapSelectedTreatments,
      };

      console.log("body check =>", body);

      await axios.post(`/use-courses/selected-treatments`, body);

      message.success("บันทึกข้อมูลสำเร็จ!");

      history.push(
        `/usedcourse/coursedetail/${id}/courseList1?itemId=${query.itemId}`
      );
    } catch (err: any) {
      console.log("err =>", err);
      message.error(err.message);
    }
  };

  const onClickOtherItem = async (item: any) => {
    console.log("on click other item...", item);

    setItemSelectedOther(item);
    setSelectedOtherTreatments([...item.otherTreatments]);

    setTreatments([]);
    setModalSelectOtherType("list");
    setModalSelectOther(true);
  };

  const onClickSelectOtherList = async () => {
    getAllTreatments();

    setModalSelectOtherType("select");
  };

  const onClickRemoveItemSelectOther = (index: number) => {
    const items: any = [...selectedOtherTreatments];
    items.splice(index, 1);
    setSelectedOtherTreatments(items);
  };

  const onClickCancelSelectOther = () => {
    setSelectedOtherTreatments([]);
    setModalSelectOther(false);
  };

  const onClickSubmitSelectOther = () => {
    const items: any = [...state.selectedTreatments];
    console.log("items selectedOtherTreatments =>", items);
    const item = items.find(
      (x: any) => x._id?.toString() === itemSelectedOther?._id?.toString()
    );
    console.log("item =>", item);
    item.otherTreatments = [...dataSelectedOtherTreatments];
    console.log("item after =>", item);
    setState({ ...state, selectedTreatments: items });

    setModalSelectOther(false);
  };

  return (
    <div>
      <HeaderBar title="USED COURSE / SO-PRO-TestB" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 20px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="80%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>เลือกรายการหัตถการ/Select Treatment </h4>
            <div className="row justify-center  mt-20">
              <div className="col-12">
                <SearchCateField
                  placeholder="Search for Name, Code"
                  color="#fff"
                  options={procedureTypes}
                  defaultValue={searchType}
                  onChange={(e: any) => searchChange(e.target.value)}
                  onTypeChange={(value: any) => searchTypeChange(value)}
                />
              </div>
            </div>
            <div className="row justify-start mt-20">
              {state.promotionType === "package" ? (
                <div className="ex3">
                  <Table
                    header={_selectTreatmentPackageColumns}
                    headerPadding="10px 10px"
                  >
                    {dataTreatments.map((item: any, index: number) => {
                      const index2 = state.selectedTreatments.findIndex(
                        (m: any) => m._id === item._id
                      );
                      //console.log("index", index2);
                      return (
                        <tr
                          key={index}
                          // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                          style={{ cursor: "pointer", border: "0px" }}
                        >
                          <TableColumn width="3%" align="center">
                            {index + 1}
                          </TableColumn>
                          <TableColumn width="7%">{item.code}</TableColumn>
                          <TableColumn width="28%">{item.name}</TableColumn>
                          <TableColumn width="10%" align="right">
                            {numberWithCommas(item.promotion?.noCourse)}
                          </TableColumn>
                          <TableColumn width="10%" align="right">
                            {item.promotion?.quantityRemain}
                          </TableColumn>
                          <TableColumn width="10%" align="center">
                            {item.treatmentUnit}
                          </TableColumn>
                          <TableColumn width="10%" align="right">
                            {numberWithCommas(item.promotion?.price, 2)}
                          </TableColumn>
                          <TableColumn width="10%" align="right">
                            {numberWithCommas(item.promotion?.discount, 2)}
                          </TableColumn>
                          <TableColumn width="10%" align="right">
                            {numberWithCommas(item.promotion?.totalPrice, 2)}
                          </TableColumn>

                          <TableColumn width="5%" align="center">
                            {index2 !== -1 ? (
                              <Icon
                                path={mdiPlusCircle}
                                size="30"
                                color="#D3D8DD"
                              />
                            ) : (
                              <div
                                onClick={(e: any) => {
                                  onHandledata(item);
                                  setIsOpen(false);
                                }}
                              >
                                <Icon
                                  path={mdiPlusCircle}
                                  size="30"
                                  color="#4D7E7F"
                                />
                              </div>
                            )}
                          </TableColumn>
                        </tr>
                      );
                    })}
                  </Table>
                </div>
              ) : (
                <div className="ex3">
                  <Table
                    header={columnSelectTreatments}
                    headerPadding="10px 10px"
                  >
                    {dataTreatments.map((item: any, index: number) => {
                      const index2 = state.selectedTreatments.findIndex(
                        (m: any) => m._id === item._id
                      );
                      //console.log("index", index2);
                      return (
                        <tr
                          key={index}
                          // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                          style={{ cursor: "pointer", border: "0px" }}
                        >
                          <TableColumn width="3%" align="center">
                            {index + 1}
                          </TableColumn>
                          <TableColumn width="7%">{item.code}</TableColumn>
                          <TableColumn width="30%">{item.name}</TableColumn>
                          <TableColumn width="5%" align="center">
                            {item.treatmentUnit}
                          </TableColumn>
                          <TableColumn width="10%" align="right">
                            {state.promotionType === "buffet_special"
                              ? numberWithCommas(
                                  item.price?.special?.coursePriceLocal,
                                  2
                                )
                              : numberWithCommas(
                                  item.price?.normal?.coursePriceLocal,
                                  2
                                )}
                          </TableColumn>

                          <TableColumn width="5%" align="center">
                            {index2 !== -1 ? (
                              <Icon
                                path={mdiPlusCircle}
                                size="30"
                                color="#D3D8DD"
                              />
                            ) : (
                              <div
                                onClick={(e: any) => {
                                  onHandledata(item);
                                  setIsOpen(false);
                                }}
                              >
                                <Icon
                                  path={mdiPlusCircle}
                                  size="30"
                                  color="#4D7E7F"
                                />
                              </div>
                            )}
                          </TableColumn>
                        </tr>
                      );
                    })}
                  </Table>
                </div>
              )}
            </div>
          </div>
        </EmptyModel>

        <EmptyModel show={isOpen2} onClose={onClose2} width="40%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 20px",
            }}
          >
            <h4>Course Card ID</h4>
            <div className="row justify-center">
              R9-CN61080007 เลขที่ใบยา xxxxxx
              <br />
              ตัดคอร์สสำหรับรายการ Laser Face
            </div>
            <div className="row justify-center mt-20">
              <Input
                className="col-6 input-usedc "
                title="เลขที่บัตรคอร์ส(โปรดระบุถ้ามี)"
                value="xxx"
                onChange={() => {}}
              />
              <Input
                className="col-6 input-usedc "
                title="จำนวนที่ใช้"
                value="30,000.00"
                onChange={() => {}}
              />
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก/Cancel"
                onClick={() => {
                  setIsOpen2(false);
                }}
              />
              <MainButton
                className="mg-10"
                background="#4D7E7F"
                title="ยืนยัน/Confirm"
                onClick={() => {
                  history.push(`/usedcourse/Coursedetail/1/courseProList1`);
                }}
              />
            </div>
          </div>
        </EmptyModel>

        {/* modal select other treament */}
        <EmptyModel
          show={modalSelectOther}
          onClose={() => {
            // setModalSelectOther(false);
            onClickCancelSelectOther();
          }}
          width="80%"
        >
          <Form
            form={formSelectedOtherTreatment}
            // initialValues={}
            layout="vertical"
            className="form-primary"
            onFinish={(values: any) => {
              if (!dataSelectedOtherTreatments.length) {
                message.warning("กรุณาเลือกรายการ/Please select a item!");
                return;
              }

              onClickSubmitSelectOther();
            }}
            onFinishFailed={() => {
              message.warning(
                "กรุณาป้อนข้อมูลให้ถูกต้อง/Please enter valid information!"
              );
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px 40px",
              }}
            >
              {modalSelectOtherType === "list" ? (
                // ==================== select other treatment list ====================
                <div className="selected-other-list">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                    }}
                  >
                    <h4 className="mb-0">รายการอื่นๆ/Others</h4>
                    <div>
                      {" "}
                      <MainButton
                        title="เลือก/Select"
                        background="#4D7E7F"
                        onClick={onClickSelectOtherList}
                      />
                    </div>
                  </div>

                  <div className="row justify-start mt-20">
                    <div className="ex3">
                      <Table
                        header={_selectedOtherListColumns}
                        headerPadding="10px 10px"
                      >
                        {dataSelectedOtherTreatments.map(
                          (item: any, index: number) => {
                            const index2 = state.selectedTreatments.findIndex(
                              (m: any) => m._id === item._id
                            );
                            //console.log("index", index2);
                            return (
                              <tr
                                key={index}
                                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                                style={{ cursor: "pointer", border: "0px" }}
                              >
                                <TableColumn width="3%" align="center">
                                  {index + 1}
                                </TableColumn>
                                <TableColumn width="7%">
                                  {item.code}
                                </TableColumn>
                                <TableColumn width="24%">
                                  {item.name}
                                </TableColumn>

                                <TableColumn width="10%" align="right">
                                  {item.formatPricePerUnit}
                                </TableColumn>
                                <TableColumn width="12%" align="center">
                                  <Form.Item
                                    name={`amount-used-select-other-${index}`}
                                    rules={[
                                      {
                                        validator: async (_, value) => {
                                          // console.log("value =>", value);

                                          const isNumber = !isNaN(value);

                                          // console.log("check course =>", course);

                                          if (!value) {
                                            return Promise.reject(
                                              new Error(messageText)
                                            );
                                          } else if (!isNumber) {
                                            return Promise.reject(
                                              new Error("กรุณาป้อนตัวเลข!")
                                            );
                                          }
                                        },
                                      },
                                    ]}
                                  >
                                    <InputNumber
                                      min={1}
                                      // max={10}
                                      // defaultValue={1}
                                      className="align-right"
                                      onChange={(value) => {
                                        console.log("change =>", value);
                                        const selectedTreatments = [
                                          ...selectedOtherTreatments,
                                        ];
                                        selectedTreatments[index].amountUsed =
                                          value || 0;
                                        setSelectedOtherTreatments(
                                          selectedTreatments
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                </TableColumn>
                                <TableColumn width="10%" align="center">
                                  {item.treatmentUnit}
                                </TableColumn>
                                <TableColumn width="12%" align="right">
                                  <Form.Item
                                    name={`discount-select-other-${index}`}
                                    rules={[
                                      {
                                        validator: async (_, value) => {
                                          // console.log("value =>", value);

                                          const isNumber = !isNaN(value);

                                          // console.log("check course =>", course);

                                          // if (!value && value !== 0) {
                                          //   return Promise.reject(
                                          //     new Error(messageText)
                                          //   );
                                          // } else if (!isNumber) {
                                          //   return Promise.reject(
                                          //     new Error("กรุณาป้อนตัวเลข!")
                                          //   );
                                          // }

                                          if (!isNumber) {
                                            return Promise.reject(
                                              new Error("กรุณาป้อนตัวเลข!")
                                            );
                                          }
                                        },
                                      },
                                    ]}
                                  >
                                    <InputNumber
                                      // min={1}
                                      // max={10}
                                      // defaultValue={1}
                                      className="align-right"
                                      onChange={(value) => {
                                        console.log("change =>", value);
                                        const selectedTreatments = [
                                          ...selectedOtherTreatments,
                                        ];
                                        selectedTreatments[index].discount =
                                          value || 0;
                                        setSelectedOtherTreatments(
                                          selectedTreatments
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                </TableColumn>
                                <TableColumn width="10%" align="right">
                                  {item.formatTotalPrice}
                                </TableColumn>
                                <TableColumn width="10%" align="center">
                                  <a
                                    onClick={() =>
                                      onClickRemoveItemSelectOther(index)
                                    }
                                  >
                                    <Icon
                                      path={mdiMinusCircle}
                                      size="30"
                                      color="#E76464"
                                    />
                                  </a>
                                </TableColumn>
                              </tr>
                            );
                          }
                        )}
                        <tr style={{ fontWeight: 700 }}>
                          <td align="right" colSpan={7}>
                            รวม/Total{" "}
                          </td>
                          <td align="right">
                            {numberWithCommas(
                              totalDataSelectedOtherTreatments,
                              2
                            )}
                          </td>
                          <td></td>
                        </tr>
                      </Table>
                    </div>
                  </div>

                  <div
                    className="mt-20"
                    style={{
                      display: "flex",
                      gap: "20px",
                      justifyContent: "center",
                    }}
                  >
                    <MainButton
                      title="ยกเลิก/Cancel"
                      background="#E76464"
                      // background="#4D7E7F"
                      onClick={() => onClickCancelSelectOther()}
                    />
                    <MainButton
                      title="บันทึกข้อมูล/Submit"
                      background="#4D7E7F"
                      // background="#4D7E7F"
                      onClick={() => {
                        formSelectedOtherTreatment.submit();
                        // onClickSubmitSelectOther();
                      }}
                    />
                  </div>
                </div>
              ) : (
                // ==================== select other treatments ====================
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                    }}
                  >
                    <h4 className="mb-0">
                      เลือกรายการหัตถการ/Select Treatment
                    </h4>
                    <div>
                      {" "}
                      <MainButton
                        title="กลับรายการอื่นๆ/Return other list"
                        background="#263544"
                        // background="#4D7E7F"
                        style={{ margin: "auto" }}
                        width="300px"
                        icon={mdiArrowLeftThick}
                        iconColor="#ddd"
                        onClick={() => setModalSelectOtherType("list")}
                      />
                    </div>
                  </div>
                  <div className="row justify-center  mt-20">
                    <div className="col-12">
                      <SearchCateField
                        placeholder="Search for Name, Code"
                        color="#fff"
                        options={procedureTypes}
                        defaultValue={searchType}
                        onChange={(e: any) =>
                          searchChangeSelectOther(e.target.value)
                        }
                        onTypeChange={(value: any) =>
                          searchTypeChangeSelectOther(value)
                        }
                      />
                    </div>
                  </div>
                  <div className="row justify-start mt-20">
                    <div className="ex3-2 mb-5">
                      <Table
                        header={columnSelectTreatments}
                        headerPadding="10px 10px"
                      >
                        {allTreatments.map((item: any, index: number) => {
                          const index2 = selectedOtherTreatments.findIndex(
                            (m: any) => m._id === item._id
                          );
                          //console.log("index", index2);
                          return (
                            <tr
                              key={index}
                              // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                              style={{ cursor: "pointer", border: "0px" }}
                            >
                              <TableColumn width="3%" align="center">
                                {index + 1}
                              </TableColumn>
                              <TableColumn width="7%">{item.code}</TableColumn>
                              <TableColumn width="30%">{item.name}</TableColumn>
                              <TableColumn width="5%" align="center">
                                {item.treatmentUnit}
                              </TableColumn>
                              <TableColumn width="10%" align="right">
                                {state.promotionType === "buffet_special"
                                  ? numberWithCommas(
                                      item.price?.special?.coursePriceLocal,
                                      2
                                    )
                                  : numberWithCommas(
                                      item.price?.normal?.coursePriceLocal,
                                      2
                                    )}
                              </TableColumn>

                              <TableColumn width="5%" align="center">
                                {index2 !== -1 ? (
                                  <Icon
                                    path={mdiPlusCircle}
                                    size="30"
                                    color="#D3D8DD"
                                  />
                                ) : (
                                  <div
                                    onClick={(e: any) => {
                                      onHandledataSelectOther(item);
                                    }}
                                  >
                                    <Icon
                                      path={mdiPlusCircle}
                                      size="30"
                                      color="#4D7E7F"
                                    />
                                  </div>
                                )}
                              </TableColumn>
                            </tr>
                          );
                        })}
                      </Table>
                    </div>
                  </div>
                  {!!allTreatments.length && (
                    <div style={{ textAlign: "center" }}>
                      <MainButton
                        title="กลับรายการอื่นๆ/Return other list"
                        background="#263544"
                        // background="#4D7E7F"
                        style={{ margin: "auto" }}
                        width="300px"
                        icon={mdiArrowLeftThick}
                        iconColor="#ddd"
                        onClick={() => setModalSelectOtherType("list")}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </Form>
        </EmptyModel>

        <Form
          form={form}
          initialValues={state}
          layout="vertical"
          className="form-primary"
          onFinish={onFinish}
        >
          <div className="card-view" style={{ padding: "30px 10px" }}>
            <div className="row" style={{ padding: "0px 40px 0px 40px" }}>
              <div className="col-3">
                <Form.Item
                  name="code"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input title="รหัสโปรโมชั่น/Promotion Code" disabled={true} />
                </Form.Item>
              </div>

              <div className="col-9">
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input title="ชื่อโปรโมชั่น/Promotion Name" disabled={true} />
                </Form.Item>
              </div>
            </div>
            <div className="row" style={{ padding: "10px 40px 0px 40px" }}>
              <div className="col-3">
                <Form.Item
                  name="promotionTypeName"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="ประเภทโปรโมชั่น/Promotion Type"
                    disabled={true}
                  />
                </Form.Item>
              </div>
              <div className="col-3">
                <Form.Item
                  name="discount"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="ส่วนลด(%)/Discount(%)"
                    disabled={true}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
              <div className="col-3">
                <Form.Item
                  name="quantity"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="จำนวน/Quantity"
                    disabled={true}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
              <div className="col-3">
                <Form.Item
                  name="validityPeriod"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="ระยะเวลาที่ใช้ได้ (วัน)/Validity Period "
                    disabled={true}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row" style={{ padding: "10px 40px 0px 40px" }}>
              <div className="col-3">
                <Form.Item
                  name="total"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="รวม/Total"
                    disabled={true}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
              <div className="col-3">
                <Form.Item
                  name="used"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="ใช้ไป/Used"
                    disabled={true}
                    inputStyle={{
                      backgroundColor: "#C7F0D8",
                      borderBottom: "2px solid #C7F0D8",
                    }}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
              <div className="col-3">
                <Form.Item
                  name="balance"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="คงเหลือ/Balance"
                    disabled={true}
                    inputStyle={{
                      backgroundColor: "#FEEFC7",
                      borderBottom: "2px solid #FEEFC7",
                    }}
                    inputClassName="align-right"
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>

        <div className="selected-list">
          <div className="selected-header">
            <div className="email_type2">
              <h5 className="header-title">รายการที่เลือก/Selected List</h5>
            </div>
            <div className="button-add2">
              <MainButton
                title="เลือก/Select"
                background="#4D7E7F"
                onClick={() => {
                  onClickSelectTreatments();
                }}
              />
            </div>
          </div>
          <div className="table">
            <Form
              form={formSelected}
              // initialValues={}
              layout="vertical"
              className="form-primary"
              onFinish={onFormSelectedFinish}
              onFinishFailed={onFormSelectedFailed}
            >
              <Table header={columns} headerPadding="10px 10px">
                {dataSelectedTreatments.map((item: any, index: number) => (
                  <tr
                    key={index}
                    // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <TableColumn width="5%" align="center">
                      {item.code}
                    </TableColumn>
                    <TableColumn width="30%">
                      {item.otherType === "other" ? (
                        <a
                          style={{ color: "#5BAEA9", fontWeight: 600 }}
                          onClick={() => onClickOtherItem(item)}
                        >
                          {item.name}{" "}
                          <Icon
                            path={mdiMenuRight}
                            size="30"
                            color="#4D7E7F"
                            style={{ marginTop: "-3px" }}
                          />
                        </a>
                      ) : (
                        <span>{item.name}</span>
                      )}
                    </TableColumn>
                    <TableColumn width="10%" align="right">
                      {item.formatPrice}
                    </TableColumn>
                    <TableColumn
                      width="10%"
                      align="center"
                      padding="10px 10px 10px 10px"
                    >
                      {state.promotionType === "any" ? (
                        <>{item.amountUsed}</>
                      ) : (
                        <Form.Item
                          name={`amount-used-${index}`}
                          rules={[
                            {
                              validator: async (_, value) => {
                                // console.log("value =>", value);

                                const isNumber = !isNaN(value);

                                // console.log("check course =>", course);

                                if (!value) {
                                  return Promise.reject(new Error(messageText));
                                } else if (!isNumber) {
                                  return Promise.reject(
                                    new Error("กรุณาป้อนตัวเลข!")
                                  );
                                } else if (state?.promotionType === "package") {
                                  const item = dataSelectedTreatments[0];
                                  console.log(
                                    "check validate package here...",
                                    item
                                  );

                                  if (value > item?.promotion?.quantityRemain) {
                                    return Promise.reject(
                                      new Error(
                                        `เหลือจำนวน ${item?.promotion?.quantityRemain}`
                                      )
                                    );
                                  }
                                }
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            // max={10}
                            // defaultValue={1}
                            className="align-right"
                            onChange={(value) => {
                              console.log("change =>", value);
                              const selectedTreatments = [
                                ...state.selectedTreatments,
                              ];
                              selectedTreatments[index].amountUsed = value || 0;
                              setState({ ...state, selectedTreatments });
                            }}
                          />
                        </Form.Item>
                      )}
                    </TableColumn>
                    <TableColumn width="10%" align="center">
                      {item.treatmentUnit}
                    </TableColumn>
                    <TableColumn align="right">
                      {item.formatTotalPrice}
                    </TableColumn>
                    <TableColumn align="right">
                      {item.formatAfterDiscount}
                    </TableColumn>
                  </tr>
                ))}
              </Table>
            </Form>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "30px" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                width: "225px",
                height: "50px",
                left: "594px",
                top: "657px",
              }}
            >
              <MainButton
                title="ยกเลิก/Cancel"
                // to={`/usedCourse/coursedetail/courseListPro`}
                //width={180}
                background="#E76464"
                onClick={() => {
                  history.push(`/usedcourse/${id}`);
                }}
              ></MainButton>
            </div>
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                width: "225px",
                height: "50px",
                left: "594px",
                top: "657px",
              }}
            >
              <MainButton
                title="ยืนยัน/Confirm"
                background="#4D7E7F"
                //to={`/jobcost`}
                onClick={() => {
                  onSubmit();
                  // setIsOpen2(true);
                }}
              ></MainButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CourseListPro1;
